<br>
  <div class="p-grid">
    <div class="p-col-12">
      <h4>Equipment Type Information</h4>
    </div>
  </div>
  <br>
    <form id="equipmentTypeForm" #equipmentTypeForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-lg-8">
          <h6>Equipment Type Name</h6>
          @if (equipmentType) {
            <input pInputText #typeNameInput required name="type"  [(ngModel)]="equipmentType.type" fluid/>
          }
        </div>
        <div class="p-col-12 p-lg-2">
          <h6>Abbreviation</h6>
          @if (equipmentType) {
            <input pInputText #abbreviationInput maxlength="50" name="abbreviation"  [(ngModel)]="equipmentType.abbreviation" fluid/>
          }
        </div>
        <div class="p-col-12 p-lg-2 push-contents-to-bottom">
          <p-button
            type="submit"
            (click)="save(equipmentTypeForm)"
            severity="success"  
            [disabled]="saving"
            label="Save">
          </p-button>
          <p-button
            type="button"
            severity="warn"  
            (click)="clear(equipmentTypeForm);"
            label="Clear">
          </p-button>
        </div>
      </div>
      <div class="p-col-12 columnPadding">
        @if (equipmentTypeForm.invalid && equipmentTypeForm.submitted) {
          <div class="alert alert-danger" role="alert">
            There are errors on this page. Please correct the errors and resubmit.
          </div>
        }
      </div>
    </form>
    <br>
      <br>
        <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="equipmentTypes" [paginator]="true" [rows]="30">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field" [style.width]="col.width">
                  {{col.header}}
                  @if (col.header != '') {
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-equipmentType
            let-columns="columns"
            let-rowIndex="rowIndex">
            <tr>
              <td><span class="p-column-title">{{columns[0].header}}</span>{{equipmentType.type}}</td>
              <td><span class="p-column-title">{{columns[1].header}}</span>{{equipmentType.abbreviation}}</td>
              <td>
                <p-button
                  
                  type="button"
                  icon="pi pi-pencil"
                  (click)="edit(equipmentType)"
                  severity="info" >
                </p-button>
                <p-button
                  
                  type="button"
                  icon="pi pi-trash"
                  (click)="delete(equipmentType)"
                  severity="danger">
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <br>
